import { fadeInAnimation } from '@/app/styles';
import styled from 'styled-components';

const Grid = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;

  > div {
    padding-right: 10px;
    padding-bottom: 10px;
  }

  .item {
    position: absolute;
    z-index: 1;
  }
  .item.muuri-item-dragging {
    z-index: 3;
  }
  .item.muuri-item-releasing {
    z-index: 2;
  }
  .item.muuri-item-hidden {
    z-index: 0;
  }
  .item-content {
    position: relative;
    width: 100%;
    height: 100%;
  }
`;

const GridWrapper = styled.div`
  margin-top: 26px;
  margin-bottom: 50px;
`;

const DashCardListWrapper = styled.div`
  overflow-y: scroll;
  padding-left: 38px;
  padding-right: 38px;
  ${fadeInAnimation()}
`;

export { DashCardListWrapper, Grid, GridWrapper };
